import { endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfWeek, startOfYear } from 'date-fns';
import { ErrorToast } from '../utils/Utils';

export const transformData = (input) => ({
  filterData: {
    source: input.source.map((source) => ({
      id: source,
      name: source,
    })),
    dealerGroup: input.dealerGroup.map((dealer) => ({
      id: dealer.id,
      name: dealer.name,
    })),
    salesPipelineStatus: input.salesPipelineStatus.map((status) => ({
      id: status.id,
      name: status.title,
    })),
    plans: input.plans.map((plan) => ({
      id: plan.id,
      name: plan.title,
    })),
  },
  filterObject: {
    source: [],
    salesPipelineStatus: [],
    dealerGroupIds: [],
    plans: [],
  },
});

export const typeLabel = (value) => {
  let frequencyLabel;

  switch (value) {
    case 1:
      frequencyLabel = 'DAILY';
      break;
    case 2:
      frequencyLabel = 'WEEKLY';
      break;
    case 3:
      frequencyLabel = 'MONTHLY';
      break;
    case 4:
      frequencyLabel = 'YEARLY';
      break;
    default:
      frequencyLabel = '';
  }

  return frequencyLabel;
};
export const scoreIsDisplayed = (scoreBreakupParameters, type, checked) => {
  const updatedParams = scoreBreakupParameters?.map((param) =>
    param.columnName.toLowerCase() === type.toLowerCase() ? { ...param, isDisplayed: checked } : param,
  );
  return updatedParams;
};
export const toCamelCase = (s) => {
  const s1 = s[0].toUpperCase();
  return s1 + s.slice(1).toLowerCase();
};
export const scoreParamLogic = (scoreBreakupParameters, type, value) => {
  let updatedParams = [];
  try {
    const val = JSON.parse(value);
    updatedParams = scoreBreakupParameters.map((param) => (param.type === type ? { ...param, logic: val } : param));
  } catch (err) {
    updatedParams = scoreBreakupParameters.map((param) => (param.type === type ? { ...param, logic: {} } : param));
  }
  return updatedParams;
};

export const scoreParamEnabled = (scoreBreakupParameters, type, checked) => {
  const updatedParameters = scoreBreakupParameters?.filter((param) => param.type !== type);
  if (checked) {
    updatedParameters.push({
      type,
      isDisplayed: false,
      columnName: `${type.charAt(0).toUpperCase() + type.slice(1)} Stars`,
    });
  }
  return updatedParameters;
};

export const updateArrayState = (prevData, name, value, checked) => {
  const val = parseInt(value, 10);
  const updatedArray = checked ? [...prevData[name], val] : prevData[name]?.filter((item) => item !== val);
  return { ...prevData, [name]: updatedArray };
};

export const sortDealerships = (dealerships, sortType) => {
  const sortedArray = [...dealerships];

  if (sortType === 1) {
    sortedArray.sort((a, b) => a.id - b.id);
  } else if (sortType === 2) {
    sortedArray.sort((a, b) => a.name.localeCompare(b.name));
  }

  return sortedArray;
};

export const sortLabel = (value) => {
  let label;

  switch (value) {
    case 1:
      label = 'Dealership ID';
      break;
    case 2:
      label = 'Dealership Name';
      break;
    default:
      label = '';
  }

  return label;
};
export const orderLabel = (value) => {
  let label;

  switch (value) {
    case 'ASC':
      label = 'Ascending Order';
      break;
    case 'DESC':
      label = 'Descending Order';
      break;
    default:
      label = 'Select';
  }

  return label;
};
export const checkType = (variable) => {
  if (typeof variable === 'string') {
    return false;
  }
  return true;
};
export const convertToFormData = (data) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('startDate', data.startDate);
  formData.append('endDate', data.endDate);
  formData.append('timezone', data.timezone);
  formData.append('type', data.type);
  if (data.logo && checkType(data.logo)) {
    formData.append('logo', data.logo);
  }
  if (data.csvFile) {
    formData.append('csvFile', data.csvFile);
  }
  formData.append('category', data.category);
  if (data.highlightTopScoreLogic) {
    const parsedData = JSON.parse(data?.highlightTopScoreLogic);
    const stringifiedData = JSON.stringify(parsedData);
    formData.append('highlightTopScoreLogic', stringifiedData);
  }
  formData.append('enabled', data.enabled);
  formData.append('visibility', JSON.stringify(data.visibility));
  formData.append('scoreBreakupParameters', JSON.stringify(data.scoreBreakupParameters));
  if (data.category === 'IMPORT') {
    formData.append('rockedNetworkPartnerId', JSON.stringify(data.rockedNetworkPartnerId));
    formData.append('ranking', JSON.stringify([data.ranking]));
  }
  formData.append('departmentRoleIds', JSON.stringify(data.departmentRoleIds));
  formData.append('dealerships', JSON.stringify(data.dealerships));

  return formData;
};

export const validateStepOne = (data, add, list) => {
  if (!data?.name) {
    ErrorToast('Enter a name');
    return false;
  }
  if (data?.name && add) {
    const invalid = list?.filter((item) => item.name.toLowerCase() === data?.name.toLowerCase())?.length > 0;
    if (invalid) {
      ErrorToast('Contest name already exists');
      return false;
    }
  }
  if (!data.startDate) {
    ErrorToast('Enter a start date');
    return false;
  }
  if (!data.endDate) {
    ErrorToast('Enter an end date');
    return false;
  }
  if (!data.type) {
    ErrorToast('Select a contest type');
    return false;
  }
  if (!data.category) {
    ErrorToast('Select a category');
    return false;
  }
  if (!data.logo && add) {
    ErrorToast('Choose a logo');
    return false;
  }
  if (!data.csvFile && add && data.category === 'IMPORT') {
    ErrorToast('Choose a csv');
    return false;
  }
  if (!data.highlightTopScoreLogic) {
    ErrorToast('Enter highlight top score logic');
    return false;
  }
  if (data.highlightTopScoreLogic) {
    try {
      JSON.parse(data.highlightTopScoreLogic);
    } catch (err) {
      ErrorToast('Please enter valid json for highlight top score logic.');
      return false;
    }
  }
  if (data.enabled === undefined) {
    ErrorToast('Specify if contest is enabled');
    return false;
  }
  if (!data.visibility) {
    ErrorToast('Select visibility options');
    return false;
  }
  if (!data.scoreBreakupParameters) {
    ErrorToast('Enter valid score breakup parameters');
    return false;
  }
  if (data.scoreBreakupParameters) {
    const val = data?.scoreBreakupParameters;
    let checkArr = [];
    checkArr = val?.map(
      (item) => !(item.type === 'consistency' && item.isDisplayed && Object.keys(item.logic || {})?.length === 0),
    );
    const check = checkArr?.some((item) => item === false);
    if (check) {
      ErrorToast('Enter valid consistency logic');
      return false;
    }
    return true;
  }
  if (!data.ranking || !data.ranking.columnName || !data.ranking.orderBy) {
    if (data.category === 'IMPORT') {
      ErrorToast('Enter valid ranking criteria');
      return false;
    }
  }
  return true;
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
export const getInitialDates = (type) => {
  let startDate = '';
  let endDate = '';
  const newDate = new Date();
  if (type === 'monthly') {
    startDate = formatDate(startOfMonth(newDate, { monthStartsOn: 1 }));
    endDate = formatDate(endOfMonth(newDate, { monthStartsOn: 1 }));
  } else if (type === 'weekly') {
    startDate = formatDate(startOfWeek(newDate, { weekStartsOn: 1 }));
    endDate = formatDate(endOfWeek(newDate, { weekStartsOn: 1 }));
  } else if (type === 'yearly') {
    startDate = formatDate(startOfYear(newDate, { yearStartsOn: 1 }));
    endDate = formatDate(endOfYear(newDate, { yearStartsOn: 1 }));
  } else {
    startDate = formatDate(newDate);
    endDate = formatDate(newDate);
  }
  return {
    startDate,
    endDate,
    csvFile: null,
    forceOverride: false,
  };
};

export const getStartAndEndDates = (date, type) => {
  let startDate = '';
  let endDate = '';
  const newDate = new Date(date);
  if (type === 'monthly') {
    startDate = formatDate(startOfMonth(newDate, { monthStartsOn: 1 }));
    endDate = formatDate(endOfMonth(newDate, { monthStartsOn: 1 }));
  } else if (type === 'weekly') {
    startDate = formatDate(startOfWeek(newDate, { weekStartsOn: 1 }));
    endDate = formatDate(endOfWeek(newDate, { weekStartsOn: 1 }));
  } else if (type === 'yearly') {
    startDate = formatDate(startOfYear(newDate, { yearStartsOn: 1 }));
    endDate = formatDate(endOfYear(newDate, { yearStartsOn: 1 }));
  } else {
    startDate = date;
    endDate = date;
  }
  return {
    startDate,
    endDate,
  };
};

export const getExtractedErrorMsg = (error) => {
  const errorMessage = error.toString();
  const match = errorMessage.match(/Error:\s*(\w+)/);
  if (match && match[1]) {
    return match[1];
  }
  return '';
};

export const appendFormData = (entries) => {
  const formData = new FormData();
  Object.entries(entries).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value);
    }
  });
  return formData;
};
